import { uploadService } from './uploadService';

export const cloudService = {
  async uploadFile(file, folder = 'post-media') {
    return uploadService.uploadFile(file, folder);
  },

  async getDownloadPresignedUrl(fileUrl) {
    return uploadService.getDownloadPresignedUrl(fileUrl);
  },

  async downloadFile(fileUrl) {
    return uploadService.downloadFile(fileUrl);
  }
};

export default cloudService;
